import {Injectable} from "@angular/core";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {Observable} from "rxjs";

@Injectable({
    providedIn: "root"
})
export abstract class DeliveryPointLocal {

    /**
     * Observable that emits the current delivery point.
     * Emits a new value whenever the delivery point changes.
     */
    public abstract currentDeliveryPoint$: Observable<DeliveryPoint | null>;

    /**
     * Observable that emits the current delivery point code.
     * If there isn't returns the default DeliveryPoint code (0).
     * Emits a new value whenever the delivery point code changes.
     */
    public abstract currentDeliveryPointCode$: Observable<number>;

    public abstract getDeliveryPointCode(): number;

    public abstract getSavedDeliveryPoint(): DeliveryPoint | null;

    public abstract saveDeliveryPoint(deliveryPoint: DeliveryPoint): void;

    public abstract deleteCurrentDeliveryPoint(): void;
}
